import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import Footer from '@/app/shared/components/footer/Footer.vue';
import CabinClassTravelersDropList from '@/app/cabin-class/cabin-class-travelers.vue';
import {CabinClassTravelers} from '../shared/models/cabin-class-travelers.model';
import Trip from '../shared/models/trip.model';
import IndieInput from '@/app/shared/components/indie-input.vue';
import DatePickerComponent from '@/app/shared/components/date-picker.component.vue';
import {alliances, solutionTypes} from '../shared/common/constants';
import {debounceTime, pluck, switchMap} from 'rxjs/operators';
import {from} from 'rxjs';
import SearchBody from '@/app/shared/models/search-body.model';
import Itinerary from '../shared/models/itinerary.model';
import SearchResults from '@/app/shared/models/search-results.model';
import MoreOptions, {TripSegments} from 'app/shared/models/trip-segments.model';
import SkeletonAnimation from '@/app/shared/components/skeleton-animation/skeleton-animation.vue';
import store from '../../store';
import {SliderPlugin} from "@syncfusion/ej2-vue-inputs";
import {Inject} from 'inversify-props';
import {SearchService} from '@/app/services/search.service';
import Toasted from 'vue-toasted';
import moment from 'moment';
import {TimeService} from '@/app/services/time.service';
import {TasksService} from '@/app/services/tasks.service';
import {CrmLogService} from "../services/crm-log.service";
import {Currencies} from "@/app/shared/common/currencies";
import LoadingEstimateComponent from "../../app/loading-estimate/loading-estimate.component";
import EstimateResult from "@/app/shared/models/estimate-result.model";
import SearchResultsSorter from "./search-results-sorter";
import Helpers from "@/app/shared/common/helpers";
import {CreditService} from "@/app/services/credit.service";
import AirlineCreditInfoOverlay from "@/app/shared/components/airline-credit-info-overlay.component.vue";

Vue.use(Toasted);
Vue.use(SliderPlugin);

@Component<SearchResultPage>({
  components: {
    Footer,
    CabinClassTravelersDropList,
    DatePickerComponent,
    IndieInput,
    SkeletonAnimation,
    LoadingEstimateComponent,
    AirlineCreditInfoOverlay
  },

  beforeRouteLeave (to, from, next) {
    if(to.path.search('/search-result/') !== 0){
      this.$toasted.clear();
    }
    next();
  },

  subscriptions() {
    return ({
      news: this.$fromDOMEvent('.indieInput', 'keyup').pipe(
        debounceTime(300),
        pluck<Event, any>('target'),
        switchMap(value => from(
          this.getCities(value.value).then((res: any) => {
            const splitString = value.name.split(" ");

            if (splitString[1] === 'Departure') {
              this.trips[+splitString[0]].fromCityList = res.data.response;
            } else {
              this.trips[+splitString[0]].toCityList = res.data.response;
            }
            if (res.data.response.length < 1) {
              this.listIsEmpty = true;
              this.trips[+splitString[0]].fromListEmpty = true;
            } else {
              this.listIsEmpty = false;
              this.trips[+splitString[0]].fromListEmpty = false;
            }
            this.cityList = res.data.response;
            this.searchInProcess = false;
            this.cityListSort(+splitString[0]);
          })
          )
        )
      )
    });
  }
})
export default class SearchResultPage extends Vue {
  @Inject() private readonly searchService: SearchService;
  @Inject() private readonly timeService: TimeService;
  @Inject() private readonly tasksService: TasksService;
  @Inject() private readonly creditService: CreditService;

  public readonly solutionTypes = solutionTypes;
  public passengerQuantity = 1;
  public cabinClassTravelers: CabinClassTravelers;
  public forceUpdate = true;
  public isValidForm = true;

  public selectedSolutionId: number = 1;
  private solutionType = -1;
  private solutions: any = [];
  private currentSolution: any = {};

  public itinerary_id: number;
  public listIsEmpty = false;
  public airlineNotSelected = false;
  public persons = 1;
  public ticks = {
    placement: "After",
    // 3 * 3600000 milliseconds = 3 Hour
    largeStep: 3 * 3600000,
    smallStep: 3600000,
    showSmallTicks: true
  };
  public tooltip = {
    placement: "Before",
    isVisible: true,
    cssClass: "e-tooltip-cutomization"
  };
  public step = 3600000 / 6;
  public min = new Date(2013, 6, 13, 1).getTime();
  public max = new Date(2013, 6, 13, 23).getTime();
  public value = [
    new Date(2013, 6, 13, 1).getTime(),
    new Date(2013, 6, 13, 23).getTime()
  ];
  public slidervalue = new Date(2013, 6, 13, 23).getTime();
  public cityList: Array<Itinerary> = [];
  public checkedAlliances: Array<AirlineSelect>;
  public departure = "Departure city";
  public arrival = "Arrival city";
  public toggle = false;
  public currentIndex: number;
  public sortOptions = [
    { checked: true },
    { checked: false },
    { checked: false },
    { checked: false },
    { checked: false }
  ];
  public filteredAirlines = [
    { checked: true },
    { checked: false },
    { checked: false },
    { checked: false },
  ];
  public segments: any = [];
  public times: any = [];
  public rows = 3;
  public perPage = 1;
  public currentPage = 1;
  public sortStops = 'any';
  public isSearching = false;
  public isUpdating = false;
  public tripSearch = store.state.search;
  public totalCost = 0;
  public allLegsFares: any = [];
  public trips: Array<Trip> = [];
  public currentPrice: Array<number> = [];
  public responsePassengerQuantity = 1;
  public searchInProcess = false;
  public isSelectingAirlines:boolean = false;
  public alliances = alliances;
  public moreOptions: Array<MoreOptions> = [];
  public prevMoreOptions: Array<MoreOptions> = [];
  public filteredMoreOptions: Array<MoreOptions> = [];
  public prevFilteredMoreOptions: Array<MoreOptions> = [];
  public options: Array<TripSegments> = [];
  public searchResults: SearchResults;
  public buttonIsVisible:boolean = false;
  public prevTrips: Array<Trip> = [];
  public allPassengers = 1;
  public estimateResult: EstimateResult = new EstimateResult();
  public readonly toasts: any = {
    flightsExpired: {name: "toast_flights_expired", message: "These flights may no longer be available. For the best results please run the search again", options: {duration: 5000, singleton: true}},
    flightsNotSelected: {name: "toast_flights_not_selected", message: "Please select all your flights before you can book" , options: {duration: 5000, singleton: true}},
    flightsNotFound: {name: "toast_flights_not_found", message: "We're sorry. No flights were found. Please try again with alternate cities or a different cabin class.",
      options: {duration: 20000, theme: "toasted-primary", type: "error", position: "bottom-center"}
    }
  };
  public bookButtonKey: number = Math.random();
  public bookButtonKeyBottom: number = Math.random();
  public key_tabContent: any = Math.random();
  public shouldShowCreditInfoBox: boolean = false;
  public isLoadingPrice: boolean = false;

  private currencies: Currencies;
  private flightResultResponse: any = [];
  private flexibleDates: boolean = false;
  private includeNearby: boolean = false;
  private airport_change: boolean = false;
  private itinerary: Array<Itinerary> = [];
  private isCabClassTravOpen = false;
  public searchBody: SearchBody;
  private round_trip = false;
  // it's for filters toggle
  private toggleBar = false;
  // private filterDuration = '';
  // private toggleFilter = false;
  private selectedSegments: Array<any> = [];
  private chunk_id: Array<number>;

  private searchResultsExpired: boolean = false;
  private resultsExpirationTask: boolean = false;
  private crmLogService: CrmLogService;
  private readonly checkExpirationFrequency = 30000;

  @Watch("buttonIsVisible", {deep: true, immediate: true})
  onButtonIsVisibleChanged(newVal: any, oldVal: any){
    this.bookButtonKey = this.bookButtonKey + 1;
    this.bookButtonKeyBottom = this.bookButtonKeyBottom + 1;
  }

  /*@Watch("allLegsFares", {deep: true, immediate: true})
  onAllLegsFaresChanged(newVal: any, oldVal: any){
    console.log('alf');
    console.log(newVal);
  }*/

  get bookingTooltipText(){
    if(this.searchResultsExpired){
      return this.toasts.flightsExpired.message;
    } else if(!this.buttonIsVisible){
      return this.toasts.flightsNotSelected.message;
    }
    return "";
  }

  constructor() {
    super();
    this.currencies = new Currencies(this.searchService);

    let trip = new Trip();
    trip.date = moment(new Date(), 'DD-MMM-YYYY').format('DD-MMM-YYYY');
    this.trips.push(trip);
    this.cabinClassTravelers = new CabinClassTravelers();
    this.searchResults = new SearchResults();
    this.searchBody = this.tripSearch;
    let localStorageTrips = store.state.trips;

    if (this.tripSearch) {
      if (localStorageTrips.length > 0) {
        this.trips = localStorageTrips
      }

      this.itinerary = this.tripSearch.itinerary || [
        { city: '', date: '', lat: 0, lng: 0, name: '' },
      ];

      this.flexibleDates = this.tripSearch.filters.flexible_dates || false;
      this.includeNearby = this.tripSearch.filters.include_nearby || false;
      this.airport_change = this.tripSearch.filters.airport_change || false;

      switch (this.tripSearch.filters.cabin) {
        case 'Y':
          this.cabinClassTravelers.cabinClass = 'Economy';
          break;
        case 'F':
          this.cabinClassTravelers.cabinClass = 'First';
          break;
        case 'C':
          this.cabinClassTravelers.cabinClass = 'Business';
          break;
        default:
          this.cabinClassTravelers.cabinClass = 'Economy';
          break;
      }

      this.cabinClassTravelers.travelers.adults = this.tripSearch.travelers.A;
      this.cabinClassTravelers.travelers.childrens = this.tripSearch.travelers.C;
      this.cabinClassTravelers.travelers.infants = this.tripSearch.travelers.I;
      this.passengerQuantity = this.tripSearch.travelers.A + this.tripSearch.travelers.C;
    }

    this.currentIndex = this.trips.length;

    if (this.tripSearch.filters.alliance.length > 0) {
      this.checkedAlliances = [
        { id: 0, checked: this.tripSearch.filters.alliance.includes('0') || true, title: 'Any Airlines' },
        { id: 1, checked: this.tripSearch.filters.alliance.includes('1') || this.tripSearch.filters.alliance.includes('0') || false, title: 'One World' },
        { id: 2, checked: this.tripSearch.filters.alliance.includes('2') || this.tripSearch.filters.alliance.includes('0') || false, title: 'Sky Team' },
        { id: 3, checked: this.tripSearch.filters.alliance.includes('3') || this.tripSearch.filters.alliance.includes('0') || false, title: 'Star Alliance' }
      ];
      if (this.tripSearch.currency) {
        this.currencies.setCurrent(this.tripSearch.currency);
      }
    } else {
      this.checkedAlliances = [
        { id: 0, checked: true, title: 'Any Airlines' },
        { id: 1, checked: true, title: 'One World' },
        { id: 2, checked: true, title: 'Sky Team' },
        { id: 3, checked: true, title: 'Star Alliance' }
      ];
      this.currencies.setCurrent('USD');
    }

    if (this.trips[0].fromCityObject) {
      this.currencies.setCurrent(this.trips[0].fromCityObject.currency);
    }

    this.$nextTick(() => {
      window.scrollTo(0, 0);

      this.currencies.getCurrency();

      if (this.tripSearch) {
        this.itinerary = this.tripSearch.itinerary || [
          { city: '', date: '', lat: 0, lng: 0, name: '' },
        ];
        if (this.searchRequestIssued()) {
          this.estimateSearchRequest();
          this.search();
        }else{
          this.loadSearchResults();
        }
      }
    });
    this.rows = this.trips.length;
    this.registerFlightsExpirationNotice();
    this.crmLogService = new CrmLogService();
    let shouldShowChangePanel = store.state.should_show_change_panel;
    if(shouldShowChangePanel){
      this.toggleBar = true;
      this.$store.dispatch("clearFlagForChangeFlightsPanel", {});
    }
  }

  public refreshTabContent(){
    this.key_tabContent = Math.random();
  }

  private registerToasts(){
    this.$toasted.register(this.toasts.flightsNotSelected.name, this.toasts.flightsNotSelected.message, this.toasts.flightsNotSelected.options);
    this.$toasted.register(this.toasts.flightsExpired.name, this.toasts.flightsExpired.message, this.toasts.flightsExpired.options);
    this.$toasted.register(this.toasts.flightsNotFound.name, this.toasts.flightsNotFound.message, this.toasts.flightsNotFound.options);
  }

  private loadSearchResults() {
    if (this.$route.params.itinerary && this.$route.params.solution) {
      this.itinerary_id = parseInt(this.$route.params.itinerary);
      this.selectedSolutionId = parseInt(this.$route.params.solution);
      this.searchFilterResult(0, this.selectedSolutionId);
      return true;
    }
    return false;
  }

  public searchRequestIssued(){
    return store.state.isNeedToStartSearch
  }

  public optionAirline(flightOption: any){
    if(flightOption){
      if(flightOption.hasOwnProperty("segments")){
        return {
          airline: flightOption.segments[0].stops[0].airline,
          airline_name: flightOption.segments[0].stops[0].airline_name,
          airline_img: flightOption.segments[0].stops[0].airline_img
        };
      } else if(flightOption.hasOwnProperty("stops")){
        return {
          airline: flightOption.stops[0].airline,
          airline_name: flightOption.stops[0].airline_name,
          airline_img: flightOption.stops[0].airline_img
        };
      }
    }
    return {
      airline: null,
      airline_name: null,
      airline_img: null
    }
  }

  public paginationAction() {
    let pagination = document.querySelector(".pagination") as HTMLElement;

    pagination.addEventListener('click', () => {
      let paginationItem = document.querySelectorAll(".page-item");
      let lastItem = paginationItem[paginationItem.length - 1];
      if (lastItem.classList.contains("disabled")) {
        pagination.classList.add('justify-content-end');
      } else {
        pagination.classList.remove('justify-content-end');
      }
    });
  }

  mounted() {
    this.paginationAction();
    this.registerToasts();
  }

  public cityListSort(id: number) {
    for (let i = 0; i < this.trips[id].fromCityList.length; i++) {
      if (this.trips[id].fromCityList[i + 1]) {
        let first = this.trips[id].fromCityList[i];
        let second = this.trips[id].fromCityList[i + 1];
        if (first.city < second.city) {
          this.trips[id].fromCityList[i + 1] = first;
          this.trips[id].fromCityList[i] = second;
        }
      }
    }
    for (let i = 0; i < this.trips[id].toCityList.length; i++) {
      if (this.trips[id].toCityList[i + 1]) {
        let first = this.trips[id].toCityList[i];
        let second = this.trips[id].toCityList[i + 1];
        if (first.city < second.city) {
          this.trips[id].toCityList[i + 1] = first;
          this.trips[id].toCityList[i] = second;
        }
      }
    }
  }

  public getCities(value: string) {
    this.cityList = [];
    this.searchInProcess = true;
    return this.searchService.getCityList(value)
  }

  public goToBooking() {
    if(!this.searchResultsExpired && this.buttonIsVisible && !this.isUpdating){
      store.commit('itineraryId', this.itinerary_id);
      store.commit('resultId', this.selectedSolutionId);
      this.currencies.commitToStore(store, 'currency');

      this.crmLogService.add(CrmLogService.LOG_CLICKED_BOOK, {
        itinerary_id: this.itinerary_id,
        details: this.searchResults.results.fares
      });

      this.$router.push({path: '../../booking-page'});
    } else {
      if(this.searchResultsExpired) {
        this.$toasted.global[this.toasts.flightsExpired.name]();
      } else if(!this.buttonIsVisible){
        this.$toasted.global[this.toasts.flightsNotSelected.name]();
      }
    }
  }

  private pickingResponseValues(response: any, legSegmentIndex: number, fareSegmentIdx: number) {
    response.forEach((option: any, optionIndex: number) => {
      let currOption = {
        all_flights_duration: this.timeService.flightTimeFormat(option.duration),
        all_stops: option.stops,
        all_layover_time: '',
        segments: [],
        price: option.price,
        consolidator: option.consolidator,
        airport_change: false,
        id: optionIndex
      };

      if (typeof (currOption.all_stops) !== 'number') {
        currOption.all_stops = currOption.all_stops.length;
      }

      currOption.price.total = (currOption.price.total * this.currencies.getExchangeRate()).toFixed();
      currOption.price.total = currOption.price.total * this.currencies.getExchangeRate();
      this.moreOptions.push(currOption);
      let layoverTime: any = 0;

      const segment = option.segments[fareSegmentIdx];
      let currSegment = {
        airline: segment.airline,
        airline_name: segment.airline_name,
        airline_img: `/img/airlines/${segment.airline}.png`,
        departure_date: this.timeService.dateFormat(segment.departure.date),
        departure_time: this.timeService.timeFormat(segment.departure.time),
        arrival_date: this.timeService.dateFormat(segment.arrival.date),
        arrival_time: this.timeService.timeFormat(segment.arrival.time),
        flight_duration: this.timeService.flightTimeFormat(segment.duration),
        price: currOption.price,
        stops: [],
        segment_idx: fareSegmentIdx,
        chunk_id: option.chunk_id,
        fare_id: option.fare_id
      };
      if (this.moreOptions[optionIndex]) {
        this.moreOptions[optionIndex].segments.push(currSegment);
      }
      for (let i = 0; i < segment.stops.length; i++) {
        if (segment.stops[i + 1] && segment.stops[i].arrival.airport !== segment.stops[i + 1].departure.airport) {
          currOption.airport_change = true;
        }
      }

      segment.stops.forEach((stop: any) => {
        switch (stop.cabin) {
          case 'Y':
            stop.cabin = 'Economy';
            break;
          case 'F':
            stop.cabin = 'First';
            break;
          case 'C':
            stop.cabin = 'Business';
            break;
          default:
            stop.cabin = 'Economy';
            break;
        }

        let currStop = {
          airline: stop.airline,
          airline_name: stop.airline_name,
          airline_img: `/img/airlines/${stop.airline}.png`,
          departure_city: stop.departure.desc,
          departure_code: stop.departure.airport,
          departure_date: this.timeService.dateFormat(stop.departure.date),
          departure_time: this.timeService.timeFormat(stop.departure.time),
          flight_duration: this.timeService.flightTimeFormat(stop.duration),
          arrival_city: stop.arrival.desc,
          arrival_code: stop.arrival.airport,
          arrival_date: this.timeService.dateFormat(stop.arrival.date),
          arrival_time: this.timeService.timeFormat(stop.arrival.time),
          cabin_class: stop.cabin,
          bags_recheck_required: stop.bags_recheck_required,
          layover_time: this.timeService.flightTimeFormat(stop.layover_time)
        };

        layoverTime = layoverTime + stop.layover_time;

        this.moreOptions[optionIndex].segments[this.moreOptions[optionIndex].segments.length-1].stops.push(currStop);

      });
      currOption.all_layover_time = this.timeService.flightTimeFormat(layoverTime);

      this.segments[legSegmentIndex].push(currOption);

    });
  }

  private createSegments(res: any) {
    this.segments = [];
    if (!res.data.response.segments_normalized) {
      for (let i = 0; i < res.data.response.fares.length; i++) {
        for (let j = 0; j < res.data.response.fares[i].segments.length; j++) {
          this.segments.push([]);
        }
      }
      return;
    }
    if (res.data.response.segments_normalized.length > 0) {
      for (let j = 0; j < res.data.response.segments_normalized.length; j++) {
        this.segments.push([]);
      }
    }
  }

  private estimateSearchRequest() {
    let estSearchBody = this.searchBody;
    /*let estSearchBody = Helpers.clone(this.searchBody);
    estSearchBody.itinerary = [];
    if(this.searchBody.hasOwnProperty("itinerary")){
      for(const itinStop of this.searchBody.itinerary){
        if(!itinStop.hasOwnProperty('byland') || (itinStop.hasOwnProperty("byland") && parseInt(itinStop.byland) === 0)){
          estSearchBody.itinerary.push(Helpers.clone(itinStop));
        }
      }
    }*/
    return this.searchService.estimateSearch(estSearchBody)
      .then( async res => {
        let response = res.data.response;
        this.estimateResult = new EstimateResult();
        this.estimateResult.estimate = response;
      })
  }

  public async search() {
    await this.validate();
    if (!this.isValidForm || this.airlineNotSelected) {
      return;
    }

    this.toggleBar = false;

    this.solutionType = solutionTypes.bestValue;
    this.selectedSegments = [];
    this.buttonIsVisible = false;
    this.allLegsFares = [];
    this.segments = [];
    this.moreOptions = [];
    this.filteredMoreOptions = [];
    this.chunk_id = [];
    this.itinerary_id = 0;
    this.selectedSolutionId = -1;
    this.solutions = [];
    this.prevTrips = [];
    this.itinerary = [];

    this.trips.forEach(trip => {
      trip.isMissing = false;
    });

    await this.searchingValuesFixation();

    store.commit('cleanSegments');
    this.isSearching = true;

    this.moreOptions = [];

    store.commit('startSearch');
    await this.searchRequest(true);
    store.commit('stopSearch');
  }

  private searchRequest(newSearch?: boolean) {
    return this.searchService.search(this.searchBody)
      .then(res => {
        if (res.data.status === 'error' || res.data.response.fares === null) {
          this.isSearching = false;
          this.$toasted.global[this.toasts.flightsNotFound.name]();

          if (!res.data.response.fnf) return;
          if(res.data.response.fnf){
            this.trips.forEach(trip => {
              for (let i = 0; i < res.data.response.fnf.length; i++) {
                if (res.data.response.fnf[i].departure_date === moment(trip.date).format('MM/DD/YYYY')) {
                  trip.isMissing = true;
                }
              }
            });
          }
          this.$store.dispatch('enableFnfNotice', {});
          this.$router.push('/');
        }

        let response = res.data.response;
        store.commit('saveSearchResults', response)
        this.searchResults.search = response;
        if (response.fares) {
          let chunk_id: Array<number> = [];
          let group_id: Array<number> = [];

          for (let i = 0; i < response.fares.length; i++) {
            chunk_id.push(response.fares[i].chunk_id);
            group_id.push(response.fares[i].group_id);
          }
          this.chunk_id = chunk_id;
          this.itinerary_id = +res.data.response.itinerary_id;
          let itinerary_id = +res.data.response.itinerary_id;
          this.getSolutions(itinerary_id, newSearch);
        }
        this.showCreditInfoOverlayIfNeeded();
      });

  }

  private getSolutions(itinerary_id: number, newSearch?: boolean) {
    this.searchService.getSolutions({ itinerary_id: itinerary_id })
      .then(res => {
        let response = res.data.response;
        store.commit('saveSolutions', response);
        this.searchResults.solutions = response;
        this.selectedSolutionId = res.data.response.solutions_info.solutions[this.solutionType].result_id;
        this.itinerary_id = itinerary_id;

        let body = {
          currency: this.currencies.default,
          itinerary_id: `${itinerary_id}`,
          filter: 0,
          results_mode: 1
        };

        this.getSearchResults(body, newSearch);
      })
  }

  private async getSearchResults(body: any, newSearch?: boolean) {

    this.searchService.getFlightsResults(body)
      .then(async res => {
        if (!this.solutions[3]) {
          for (let i = 0; i < 5; i++) {
            this.solutions.push(res.data.response.solutions_info.solutions[i]);
            this.solutions[this.solutions.length - 1].price = this.solutions[this.solutions.length - 1].price;
          }
        }
        this.searchFilterResult(this.solutionType, 0, newSearch);
      })
  }

  public searchFilterResult(solutionType: number, solutionId?: number, newSearch?: boolean) {
    if(solutionType != this.solutionType){
      this.deselectAllSegments();
    }
    this.solutionType = solutionType;
    if (!solutionId && !this.solutions[4]) return;
    this.isSearching = true;

    this.prevTrips = [];
    for (let i = 0; i < this.trips.length; i++) {
      this.prevTrips.push(this.trips[i]);
      this.prevTrips[i].date = moment(this.prevTrips[i].date, 'DD-MMM-YYYY').format("ddd DD-MMM-YYYY");
    }

    this.searchService.getSolutions({ itinerary_id: this.itinerary_id })
      .then(res => {
        let response = res.data.response;
        store.commit('saveSolutions', response);
        this.currencies.setCurrent(response.solutions_info.currency);
        this.cabinClassTravelers.cabinClass = response.solutions_info.filters.cabin;
        switch (response.solutions_info.filters.cabin) {
          case 'Y':
            this.cabinClassTravelers.cabinClass = 'Economy';
            break;
          case 'F':
            this.cabinClassTravelers.cabinClass = 'First';
            break;
          case 'C':
            this.cabinClassTravelers.cabinClass = 'Business';
            break;
          default:
            this.cabinClassTravelers.cabinClass = 'Economy';
            break;
        }
        this.cabinClassTravelers.travelers.adults = +response.solutions_info.travelers.A;
        this.cabinClassTravelers.travelers.childrens = +response.solutions_info.travelers.C;
        this.cabinClassTravelers.travelers.infants = +response.solutions_info.travelers.I;
        this.persons = this.cabinClassTravelers.travelers.adults + this.cabinClassTravelers.travelers.childrens + this.cabinClassTravelers.travelers.infants;
        this.allPassengers = this.persons;
        this.responsePassengerQuantity = +response.solutions_info.travelers.A + +response.solutions_info.travelers.C + +response.solutions_info.travelers.I;
        this.airport_change = response.solutions_info.filters.airport_change === '1';
        this.flexibleDates = response.solutions_info.filters.flexible_dates === '1';
        this.includeNearby = response.solutions_info.filters.include_nearby === '1';

        this.solutions = [];

        for(let i in res.data.response.solutions_info.solutions){
          if(res.data.response.solutions_info.solutions[i].is_top === 1){
            this.solutions.push(res.data.response.solutions_info.solutions[i]);
          }
          if (solutionId && !newSearch && this.solutions[this.solutions.length - 1].result_id === solutionId) {
            this.solutionType = res.data.response.solutions_info.solutions[i].filter_by;
          }
        }

        this.searchResults.solutions = response;

        const solution = this.getSolutionByType(this.solutionType);
        // The price is updated in
        // @see Flow A: getResultsSolution -> addCreditInfoToFlightOptions -> calculateTotalCost -> updatePackagePriceBasedOnSelection
        // @see Flow B: selectSegment -> calculateTotalCost -> updatePackagePriceBasedOnSelection
        // @see Flow C: deselectSegment -> calculateTotalCost -> updatePackagePriceBasedOnSelection
        // It needs to be set to null here so that the UI doesn't get updated with a potentially incorrect value, confusing the user.
        if(this.creditService.isInCreditFlow(this.$store)){
          solution.price = null;
        }

        this.currentSolution = solution;

        this.selectedSolutionId = this.currentSolution.result_id;

        this.$router.replace(`/search-result/${this.itinerary_id}/${this.selectedSolutionId}`);
        this.isSearching = false;

        return this.getResultsSolution(solutionId);
      }).then(() => {
      if(!this.searchResultsExpired && !this.resultsExpirationTask){
        this.checkFlightsExpiration( this.itinerary_id );
        this.resultsExpirationTask = true;
      }
    });
  }

  private getSolutionByType(solutionType: number) {
    for(let i in this.solutions){
      if(this.solutions[i].filter_by===solutionType){
        return this.solutions[i];
      }
    }
  }

  private getResultsSolution(solution?: number){
    return Promise.resolve()
      .then(async () => this.searchService.getResult(`/flights/result/${this.selectedSolutionId}`))
      .then(async (res) => {
        if (solution) {
          this.creatingTrips(res.data.response);
        }
        let responseMoreOptions: any = [];
        this.flightResultResponse = res.data.response;
        this.searchResults.results = res.data.response;

        this.createSegments(res);
        for (let segmentIndex = 0; segmentIndex < res.data.response.segments_normalized.length; segmentIndex++) {

          let more_options = {
            result_id: this.selectedSolutionId,
            chunk_id:
                SearchResultPage.getChunkId(
                res.data.response.fares,
                res.data.response.segments_normalized[segmentIndex].fare_id
              ),
            group_id:
                SearchResultPage.getGroupId(
                res.data.response.fares,
                res.data.response.segments_normalized[segmentIndex].fare_id
              )
          };

          await this.getMoreOptions(
            more_options,
            segmentIndex,
            res.data.response.segments_normalized[segmentIndex].segment_idx,
            responseMoreOptions
          );

        }

        this.sortPrice();
        this.rows = this.prevTrips.length;
        this.allLegsFares = this.segments;
        this.isSearching = false;
        this.isUpdating = false;

        this.searchResults.more_options = responseMoreOptions;
        if (this.moreOptions) {
          this.prevMoreOptions = this.moreOptions;
          this.filteredMoreOptions = this.moreOptions;
          this.isSearching = false;
          this.eliminateSegmentDuplicates();
        }
        this.addCreditInfoToFlightOptions(this.allLegsFares);

        this.selectFirstIfNeeded();
        this.updateBookingButtonVisibility();
      });
  }

  private addCreditInfoToFlightOptions(allLegsFares: any[]){
    this.creditService.getSelectedAirlineCreditOptions(this.$store).then((selectedAirlineCreditOptions) => {
      for(let leg of allLegsFares){
        leg._has_airline_credit_available = false;
        for(let flightOption of leg){
          flightOption.has_airline_credit = false;
          const optionAirline = this.optionAirline(flightOption).airline;
          if(selectedAirlineCreditOptions){
            for(let airlineCredit of selectedAirlineCreditOptions){
              if(optionAirline == airlineCredit.airline_code){
                flightOption.has_airline_credit = true;
                leg._has_airline_credit_available = true;
                this.currentSolution._has_airline_credit_available = true;
                this.getSolutionByType(this.currentSolution.filter_by)._has_airline_credit_available = true;
              }
            }
          }
        }
      }
      this.calculateTotalCost().then((newTotal) => {
        this.totalCost = newTotal;
        store.commit('totalCost', this.totalCost);
      });
      this.refreshTabContent();
    });
  }

  private updatePackagePriceBasedOnSelection(total: number){
    let isCreditUsed = this.creditService.isInCreditFlow(this.$store);

    if(isCreditUsed){

      //let total = 0;
      let origPrice = this.currentSolution.price_start;
      let updatedPrice = origPrice;
      let usedCreditByAirline: any = {};
      //let availableCreditByAirline: any = {};
      const selectedFlightOptions = this.$store.state.selectedSegments;
      const currentTotalCost = this.$store.state.totalCost;
      return this.creditService.getSelectedAirlineCreditData(this.$store)
        .then((res) => {
          console.log("----- price update -----");
          console.log("Original Price: " + origPrice);
          for(let airlineCode in res){
            if(res.hasOwnProperty(airlineCode)){
              const totalCreditAmount = res[airlineCode].total_amount;
              for(let flightOption of selectedFlightOptions){
                let optionAirline = this.optionAirline(flightOption).airline;
                if( optionAirline == airlineCode){
                  console.log('fo');
                  console.log(flightOption);

                  let dbgMsgReason = "";

                  let usedSoFar = 0.0;
                  if(usedCreditByAirline.hasOwnProperty(airlineCode)){
                    usedSoFar = usedCreditByAirline[airlineCode];
                  }
                  const creditAvailable = totalCreditAmount - usedSoFar;
                  if(creditAvailable > 0){
                    const optionPrice = parseFloat(flightOption.price.total);
                    let amountToSubstract = creditAvailable;
                    if(amountToSubstract > optionPrice){
                      amountToSubstract = optionPrice;
                      dbgMsgReason = " (maxed out at option price)";
                    }
                    if(amountToSubstract > updatedPrice){
                      amountToSubstract = updatedPrice;
                      dbgMsgReason = " (maxed out at updated package price)";
                    }
                    console.log("Current total price: " + updatedPrice);
                    console.log("Option price is: " + optionPrice);
                    console.log("Total credit available for " + optionAirline + ": " + totalCreditAmount);
                    console.log("Credit used so far for " + optionAirline + ": " + usedSoFar);
                    console.log("Credit available for " + optionAirline + ": " + creditAvailable);
                    console.log("Subtracting: " + amountToSubstract + " for " + airlineCode + dbgMsgReason);

                    updatedPrice -= amountToSubstract;
                    if(!usedCreditByAirline.hasOwnProperty(airlineCode)){
                      usedCreditByAirline[airlineCode] = 0.0;
                    }
                    usedCreditByAirline[airlineCode] += amountToSubstract;

                    console.log("Updated price " + updatedPrice );
                    console.log("---");
                  }
                }
              }
            }
          }
          this.$store.dispatch("storeUsedCreditByAirline", usedCreditByAirline);

          if(!isNaN(updatedPrice)){
            this.setIsLoadingPrice(true);
            setTimeout(() => {this.setIsLoadingPrice(false)}, 1000);
            this.currentSolution.price = updatedPrice;
          }
          return this.currentSolution.price;
        });


    } else {
      return Promise.resolve().then(() => {
        this.currentSolution.price = this.currentSolution.price_start;
        return this.currentSolution.price
      });
    }

  }

  private setIsLoadingPrice(isLoading: boolean){
    this.isLoadingPrice = isLoading;
  }

  private selectFirstIfNeeded(){
    let shouldAutoSelectFirstOption = this.$store.state.should_select_first_option_for_all_legs;
    if(shouldAutoSelectFirstOption){
      this.uiSelectFirstOptionUpToPage();
      this.$store.dispatch("clearSelectFirstOptionForAllLegs", {});
    }
  }

  private async getMoreOptions(more_options: any, segmentIndex: number, fareSegmentIdx: number, responseMoreOptions: any) {
    return this.searchService.getMoreOptions(more_options)
      .then(async res => {
        let response = res.data.response;
        this.prevFilteredMoreOptions = this.filteredMoreOptions;
        store.commit('saveMoreOptions', response);
        if (typeof (response) !== 'string') {
          await this.pickingResponseValues(response, segmentIndex, fareSegmentIdx);
          this.moreOptions = [];
          responseMoreOptions.push(response);
        }

        const segmentRef = this.flightResultResponse.segments_normalized[segmentIndex]; // short-ref

        let currOption: any = {
          all_flights_duration: this.timeService.flightTimeFormat(segmentRef.duration),
          all_stops: segmentRef.stops,
          all_layover_time: '',
          segments: [],
          price: segmentRef.price,
          consolidator: segmentRef.consolidator,
          id: this.segments[segmentIndex].length
        };

        if (typeof (currOption.all_stops) !== 'number') {
          currOption.all_stops = currOption.all_stops.length;
        }

        currOption.price.total = (currOption.price.total * this.currencies.getExchangeRate()).toFixed();

        let currSegment = {
          airline: segmentRef.stops[0].airline,
          airline_name: segmentRef.airline,
          airline_img: `/img/airlines/${segmentRef.stops[0].airline}.png`,
          departure_date: this.timeService.dateFormat(segmentRef.departure.date),
          departure_time: this.timeService.timeFormat(segmentRef.departure.time),
          arrival_date: this.timeService.dateFormat(segmentRef.arrival.date),
          arrival_time: this.timeService.timeFormat(segmentRef.arrival.time),
          flight_duration: this.timeService.flightTimeFormat(segmentRef.duration),
          price: segmentRef.price,
          stops: [],
          segment_idx: fareSegmentIdx,
          chunk_id: segmentRef.chunk_id,
          fare_id: segmentRef.fare_id
        };

        currOption.segments.push(currSegment);

        let stops: any = [];
        let layoverTime: any = 0;
        this.flightResultResponse.segments_normalized[segmentIndex].stops.forEach((stop: any) => {
          let currStop = {
            airline: stop.airline,
            airline_name: stop.airline_name,
            airline_img: `/img/airlines/${stop.airline}.png`,
            departure_city: stop.departure.desc,
            departure_code: stop.departure.airport,
            departure_date: this.timeService.dateFormat(stop.departure.date),
            departure_time: this.timeService.timeFormat(stop.departure.time),
            flight_duration: this.timeService.flightTimeFormat(stop.duration),
            arrival_city: stop.arrival.desc,
            arrival_code: stop.arrival.airport,
            arrival_date: this.timeService.dateFormat(stop.arrival.date),
            arrival_time: this.timeService.timeFormat(stop.arrival.time),
            cabin_class: stop.cabin,
            bags_recheck_required: stop.bags_recheck_required,
            layover_time: this.timeService.flightTimeFormat(stop.layover_time)
          };

          layoverTime = layoverTime + stop.layover_time;
          switch (currStop.cabin_class) {
            case 'Y':
              currStop.cabin_class = 'Economy'
              break;
            case 'F':
              currStop.cabin_class = 'First'
              break;
            case 'C':
              currStop.cabin_class = 'Business'
              break;
            default:
              currStop.cabin_class = 'Economy'
              break;
          }
          stops.push(currStop);
        });

        layoverTime = this.timeService.flightTimeFormat(layoverTime);
        currOption.all_layover_time = layoverTime;

        currOption.segments[0].stops = stops;
        this.segments[segmentIndex].push(currOption);

      })
  }

  get allLegsFaresSorted() {
    SearchResultsSorter.sortFares(this.allLegsFares, this.solutionType, this.flexibleDates);
    return this.allLegsFares;
  }

  private sortPrice() {

    // wait for all segments to be set
    for (let i = 0; i < this.segments.length; i++) {
      if( typeof(this.segments[i][0]) === 'undefined' ){
        setTimeout(this.sortPrice, 500);
        return;
      }
    }

    for (let i = 0; i < this.segments.length; i++) {
      this.segments[i].sort((a: any, b: any) => (+a.price.total > +b.price.total) ? 1 : ((+b.price.total > +a.price.total) ? -1 : 0));
      this.times.push({ from: '1:00', to: '23:00' });

      this.currentPrice[i] = this.segments[i][0].price.total;
    }
    this.selectedSegments.length = this.segments.length;
  }

  private creatingTrips(res: any) {
    let trips: Array<Trip> = [];

    let fromCityObject = new Itinerary();
    let toCityObject = new Itinerary();
    if(res && res.hasOwnProperty("segments_normalized") && res.segments_normalized){
      for (let i = 0; i < res.segments_normalized.length; i++) {

        fromCityObject = res.itinerary[i];
        toCityObject = res.itinerary[i+1];

        let trip: Trip = {
          date: moment(res.segments_normalized[i].departure.date, 'DDMMYY').format('DD-MMM-YYYY'),
          fromAirport: res.segments_normalized[i].departure.airport,
          fromCity: res.segments_normalized[i].departure.desc,
          fromCityObject: fromCityObject || null,
          fromCode: fromCityObject.code,
          id: i,
          lat: 0,
          lng: 0,
          toAirport: res.segments_normalized[i].arrival.airport,
          toCity: res.segments_normalized[i].arrival.desc,
          toCityObject: toCityObject || null,
          toCode: toCityObject.code,
          toLat: 0,
          toLng: 0,
          forceUpdate: false,
          toCityList: [],
          fromCityList: [],
          toListEmpty: false,
          fromListEmpty: false,
          isMissing: false,
        }
        trips.push(trip);
      }
    }

    trips.sort((a:any, b:any) => a.id - b.id );
    this.trips = trips;

    this.rows = this.prevTrips.length;
    store.commit('saveTrips', trips);
  }

  public static getChunkId(fares:[any], fare_id:number){
    if(fares){
      for( let i = 0; i < fares.length; i++ ){
        if(fare_id === fares[i].fare_id){
          return fares[i].chunk_id;
        }
      }
    }
    return 0;
  }

  public static getGroupId(fares:[any], fare_id:number){
    for( let i = 0; i < fares.length; i++ ){
      if(fare_id === fares[i].fare_id){
        return fares[i].group_id;
      }
    }
    return 0;
  }

  private eliminateSegmentDuplicates(){
    let filteredSegments: any = [];
    let keys: any = [];

    for(let legIdx in this.allLegsFares){
      keys[legIdx] = [];
      filteredSegments[legIdx] = [];

      if( this.allLegsFares[legIdx].length === 0 ){
        setTimeout(this.eliminateSegmentDuplicates, 500)
        return;
      }

      for(let optionIdx in this.allLegsFares[legIdx]) {
        let key = this.allLegsFares[legIdx][optionIdx].segments[0].airline + '#' +
          this.allLegsFares[legIdx][optionIdx].segments[0].departure_date + '#' +
          this.allLegsFares[legIdx][optionIdx].segments[0].departure_time + '#' +
          this.allLegsFares[legIdx][optionIdx].segments[0].arrival_date + '#' +
          this.allLegsFares[legIdx][optionIdx].segments[0].arrival_time + '#';
        if( typeof keys[legIdx][key] === 'undefined' ){
          filteredSegments[legIdx].push(this.segments[legIdx][optionIdx]);
          keys[legIdx][key]=1;
        }
      }
    }
    this.allLegsFares = filteredSegments;
  }

  private inputValidate() {
    for (let i = 0; i < this.trips.length; i++) {
      if (!this.trips[i].fromCity || !this.trips[i].toCity || !this.trips[i].date) {
        this.isValidForm = false;
        if (!this.airlineNotSelected) return;
      }
    }
  }

  private validate() {
    if (JSON.stringify(this.checkedAlliances).includes('true')) {
      this.airlineNotSelected = false;
    } else {
      this.airlineNotSelected = true;
    }
    this.isValidForm = true;
    this.inputValidate();
  }

  public async saveTrip() {
    // @ts-ignore
    if(store.state.indieLogin && store.state.indieLogin.isLogged()){
      await this.doSaveTrip();
    } else {
      store.dispatch('setLoginNeeded', true);
      return 0;
    }
  }

  private async doSaveTrip(){
    let selectedSegmentsAsIdsList = this.getSelectedSegmentsIdsList();
    await this.searchService.addSaveTrip({
      currency: store.state.search.currency,
      currency_rate: this.currencies.getExchangeRate(),
      itinerary_id: this.itinerary_id,
      price: store.state.totalCost,
      result_id: this.selectedSolutionId,
      selected_segments_data: selectedSegmentsAsIdsList,
      type: 0
    }).then(res => {
      //console.log(res);
      this.$toasted.info("The trip was saved");
    });
    await store.commit('saveMoreOptions', this.moreOptions);
    this.$router.push('/saved-trips');
  }

  private getSelectedSegmentsIdsList(){
    let asList: any = {};
    let selectedSegments = this.$store.state.selectedSegments;
    for(let legIdx in selectedSegments){
      asList[legIdx] = {
        fare_id: selectedSegments[legIdx].fare_id,
        segment_idx: selectedSegments[legIdx].segment_idx,
        leg_idx: legIdx
      };
    }
    return asList;
  }

  public deselectSegment(legIndex: number) {
    this.selectedSegments.splice(legIndex, 1);
    this.buttonIsVisible = false;
    this.calculateTotalCost().then((newTotal) => {
      this.totalCost = newTotal;
      store.commit('totalCost', this.totalCost);
    });
  }

  public selectSegment(segment: any, legNumIdx: number) {

    this.logSegmentChange(this.selectedSegments[legNumIdx], segment);

    const selectedFareId = this.getSelectedFareId(legNumIdx);

    this.selectedSegments[legNumIdx] = segment;
    this.currentPrice[legNumIdx] = this.calculateSegmentTotalCost(segment);

    //let segments = this.selectedSegments;
    //this.selectedSegments = [];
    //for (let i = 0; i < segments.length; i++) {
    //    this.selectedSegments.push(segments[i]);
    //}
    store.commit('selectSegments', this.selectedSegments);

    this.calculateTotalCost().then((newTotal) => {
      this.totalCost = newTotal;
      store.commit('totalCost', this.totalCost);
    });


    if(segment.fare_id !== selectedFareId){
      this.isUpdating = true;
      this.changeFareSelection(segment.segment_idx, selectedFareId, segment.fare_id, segment.chunk_id)
        .then(res => {
          this.updateBookingButtonVisibility();
          //this.uiSelectFirstOptionUpToPage(index);
        });
    } else {
      if ((this.currentPage) < this.trips.length) {
        this.currentPage++;
      }
      this.updateBookingButtonVisibility();
      //this.uiSelectFirstOptionUpToPage(this.currentPage-1);
    }

  }

  private uiSelectFirstOptionUpToPage(pageNum: number|null = null){
    let lf = this.allLegsFaresSorted;
    if(pageNum === null){
      pageNum = this.prevTrips.length - 1;
    }

    for(let p = 0; p <= pageNum; p++){
      if(lf && lf[p] && lf[p][0] && lf[p][0].segments){
        this.selectedSegments[p] = lf[p][0].segments[0];
        store.commit('selectSegments', this.selectedSegments);
      }
    }
    this.calculateTotalCost().then((newTotal) => {
      this.totalCost = newTotal;
      store.commit('totalCost', this.totalCost);
    });
  }

  /**
   * Allows resetting all selected segments at once
   */
  public deselectAllSegments(){
    this.selectedSegments = [];
    this.buttonIsVisible = false;
    store.commit('selectSegments', this.selectedSegments);
    this.calculateTotalCost().then((newTotal) => {
      this.totalCost = newTotal;
      store.commit('totalCost', this.totalCost);
    });

    this.updateBookingButtonVisibility();
    this.currentPage = 1;
  }

  private getSelectedFareId(legIndex: number) {
    let selectedFareId = 0;
    if (this.selectedSegments[legIndex] === undefined) {
      selectedFareId = this.searchResults.results.segments_normalized[legIndex].fare_id;
    } else {
      selectedFareId = this.selectedSegments[legIndex].fare_id;
    }

    return selectedFareId;
  }

  public isFareSelected(legIndex: number, segment: any) {
    let fareId = -1;
    if( this.selectedSegments[legIndex] !== undefined ){
      fareId = this.selectedSegments[legIndex].fare_id
    }
    return fareId === segment.fare_id;
  }

  private updateBookingButtonVisibility(){
    if(!this.selectedSegments.length){
      return false;
    }
    for (let i = 0; i < this.selectedSegments.length; i++) {
      if (!this.selectedSegments[i]) {
        this.buttonIsVisible = false;
        return;
      }
    }
    this.buttonIsVisible = true;
  }

  private changeFareSelection(segmentIdx: number, oldFareId: number, newFareId: number, chunkId: number) {
    const swapArgs = {
      itinerary_id: this.itinerary_id,
      filter_by: this.searchResults.results.filter,
      chunk_id: chunkId,
      fare_a: newFareId,
      fare_b: oldFareId,
      segment_idx: segmentIdx,
      result_id: this.searchResults.results.result_id
    };

    return Promise.resolve()
      .then(() => this.searchService.swapPkg(swapArgs))
      .then((res) => {
        this.itinerary_id = parseInt(res.data.response.new_itinerary_id);
        const newResultId = parseInt(res.data.response.new_result_id);
        return this.getSearchResults({
          itinerary_id: this.itinerary_id,
          result_id: newResultId
        });
      })
      .then((res) => {
        let newPath = `/search-result/${this.itinerary_id}/${this.selectedSolutionId}`;
        //Helpers.routeReplaceSilent(newPath);
        this.$router.replace(newPath);
        if ((this.currentPage) < this.trips.length) {
          this.currentPage++;
        }
      });

    /*eturn this.searchService.swapPkg(swapArgs).then(res => {

        this.itinerary_id = parseInt(res.data.response.new_itinerary_id);
        const newResultId = parseInt(res.data.response.new_result_id);

        this.getSearchResults({
            itinerary_id: this.itinerary_id,
            result_id: newResultId
        }).then(async res => {
            let newPath = `/search-result/${this.itinerary_id}/${this.selectedSolutionId}`;
            //Helpers.routeReplaceSilent(newPath);
            this.$router.replace(newPath);
            if ((this.currentPage) < this.trips.length) {
                this.currentPage++;
            }
        });

    });*/

  }

  private calculateTotalCost() {
    let total = 0;
    if( this.currentSolution.filter_by === solutionTypes.customize ){
      for (let i in this.selectedSegments) {
        if (typeof this.selectedSegments[i] !== 'undefined') {
          total += this.calculateSegmentTotalCost(this.selectedSegments[i]);
        }
      }
    }else{
      total = this.currentSolution.price;
    }
    return this.updatePackagePriceBasedOnSelection(total);
    //return total;
  }

  private calculateSegmentTotalCost(segment: any) {
    const passengersCount: any = {
      ADT: this.tripSearch.travelers.A,
      CHD: this.tripSearch.travelers.C,
      INF: this.tripSearch.travelers.I
    };
    let total = 0;
    for (let i in  segment.price.types) {
      total += passengersCount[segment.price.types[i].category] * parseInt(segment.price.types[i].total);
    }
    return total;
  }

  private logSegmentChange(oldSegment: any, newSegment: any) {
    let diff = 0;
    let details: Array<any> = [];

    if (typeof oldSegment !== 'undefined') {
      diff =  this.calculateSegmentTotalCost(newSegment) - this.calculateSegmentTotalCost(oldSegment);
      details.push(this.makeLogLine(oldSegment));
    } else {
      details.push('NONE');
    }
    details.push(this.makeLogLine(newSegment));

    this.crmLogService.add(CrmLogService.LOG_SELECTED_FLIGHT, {details, diff});
  }

  private makeLogLine(segment: any) {
    const departureCode = segment.stops[0].departure_code;
    const departureDate = segment.stops[0].departure_date;
    const arrivalCode = segment.stops[segment.stops.length - 1].arrival_code;
    const arrivalDate = segment.stops[segment.stops.length - 1].arrival_date;
    return `${departureCode} (${departureDate}) - ${arrivalCode} (${arrivalDate}) /${segment.airline} ${this.calculateSegmentTotalCost(segment)}\$`;
  }

  selectSort(selected: string) {
    this.sortOptions = [
      { checked: false },
      { checked: false },
      { checked: false },
      { checked: false },
      { checked: false }
    ];
    switch (selected) {
      case 'best':
        this.sortOptions[0].checked = true;
        break;
      case 'fewest':
        this.sortOptions[1].checked = true;
        break;
      case 'shortest':
        this.sortOptions[2].checked = true;
        break;
      case 'least':
        this.sortOptions[3].checked = true;
        break;
      case 'build':
        this.sortOptions[4].checked = true;
        break;
    }
  }

  public toCityChange(trip: Trip, currentCity: string, cityItem: Itinerary) {

    if (trip.fromCity === currentCity) {
      this.trips[trip.id].toCity = "";
      this.trips[trip.id].toCode = '';
    } else {
      this.cityList.filter((city: Itinerary) => {
        if (city.code.toLowerCase() === cityItem.code.toLowerCase()) {
          this.trips[trip.id].toCode = city.code
          this.trips[trip.id].toAirport = city.name;
          this.trips[trip.id].toLat = city.lat;
          this.trips[trip.id].toLng = city.long;
          this.trips[trip.id].toCity = currentCity;
          this.trips[trip.id].toCityObject = city;
          if (!this.trips[1] && this.trips[0].fromCity) {
            this.createNewTrip();
          } else {
            if (this.trips[trip.id + 1] && this.trips[trip.id + 1].fromCity === '') {
              this.trips[trip.id + 1].fromCode = city.code
              this.trips[trip.id + 1].fromAirport = city.name;
              this.trips[trip.id + 1].lat = city.lat;
              this.trips[trip.id + 1].lng = city.long;
              this.trips[trip.id + 1].fromCity = currentCity;
              this.trips[trip.id + 1].fromCityObject = city;
            }
          }

        }
      });
    }
    this.trips[trip.id].forceUpdate = !this.trips[trip.id].forceUpdate;
  }

  public fromCityChange(trip: Trip, currentCity: string, cityItem: Itinerary) {
    if (trip.toCity === currentCity) {
      this.trips[trip.id].toCity = "";
      this.trips[trip.id].forceUpdate = !this.trips[trip.id].forceUpdate;
    }

    this.cityList.filter((city: Itinerary) => {
      if (city.code.toLowerCase() === cityItem.code.toLowerCase()) {
        this.trips[trip.id].fromCode = city.code;
        this.trips[trip.id].fromAirport = city.name;
        this.trips[trip.id].lat = city.lat;
        this.trips[trip.id].lng = city.long;
        this.trips[trip.id].fromCity = currentCity;
        this.trips[trip.id].fromCityObject = city;
        if(trip.id == 0){
          this.currencies.setCurrent(city.currency);
        }
        if (!this.trips[1] && this.trips[0].toCity) {
          this.createNewTrip();
        }
      }
    });

  }

  public createNewTrip() {
    if (this.trips.length < 20) {
      let nextDate = moment(this.trips[this.trips.length - 1].date, 'DD-MMM-YYYY');
      nextDate.set("d", nextDate.get("d") + 7);
      const trip = new Trip();
      trip.date = nextDate.format('DD-MMM-YYYY');

      this.trips.push(trip);

      if (this.trips[this.trips.length - 2].toCity === this.trips[0].fromCity) {
        this.trips[this.trips.length - 2].toLng = 0;
        this.trips[this.trips.length - 2].toLat = 0;
        this.trips[this.trips.length - 2].toCity = '';
        this.trips[this.trips.length - 2].toCode = '';
        this.trips[this.trips.length - 2].toAirport = '';
        this.trips[this.trips.length - 2].toCityObject = null;
      }

      if (this.trips[this.trips.length - 2].toCity !== this.trips[0].fromCity) {
        this.trips[this.trips.length - 1].lng = this.trips[this.trips.length - 1].toLng;
        this.trips[this.trips.length - 1].lat = this.trips[this.trips.length - 1].toLat;
        this.trips[this.trips.length - 1].fromCity = this.trips[this.trips.length - 1].toCity;
        this.trips[this.trips.length - 1].fromCode = this.trips[this.trips.length - 1].toCode
        this.trips[this.trips.length - 1].fromAirport = this.trips[this.trips.length - 1].toAirport;
        this.trips[this.trips.length - 1].fromCityObject = this.trips[this.trips.length - 1].toCityObject;
      }

      if (this.trips.length === 2) {
        this.trips[1].fromCity = this.trips[0].toCity;
        this.trips[1].lat = this.trips[0].toLat;
        this.trips[1].lng = this.trips[0].toLng;
        this.trips[1].fromCode = this.trips[0].toCode;
        this.trips[1].fromAirport = this.trips[0].toAirport;
        this.trips[1].fromCityObject = this.trips[0].toCityObject;
      }

      this.trips[this.trips.length - 1].toCity = this.trips[0].fromCity;
      this.trips[this.trips.length - 1].toLat = this.trips[0].lat;
      this.trips[this.trips.length - 1].toLng = this.trips[0].lng;
      this.trips[this.trips.length - 1].toCode = this.trips[0].fromCode;
      this.trips[this.trips.length - 1].toAirport = this.trips[0].fromAirport;
      this.trips[this.trips.length - 1].toCityObject = this.trips[0].fromCityObject;
      this.trips[this.trips.length - 1].toCityObject!.departure_date = '';

      this.currentIndex = this.trips.length;

      this.redefineItineraryArray();
      this.searchingValuesFixation();
    }
  }

  public removeTrip(removableTrip: Trip) {
    this.currentPage = 1;
    this.forceUpdate = !this.forceUpdate;
    for (let i = 0; i < this.trips.length; i++) {
      if (removableTrip === this.trips[i]) {
        this.trips.splice(i, 1);
        if (this.trips[this.trips.length - 2]) {
          if (!this.trips[this.trips.length - 2].toCity && this.trips.length > 2) {
            this.trips[this.trips.length - 2].toCity = this.trips[0].fromCity;
            this.trips[this.trips.length - 2].toLat = this.trips[0].lat;
            this.trips[this.trips.length - 2].toLng = this.trips[0].lng;
            this.trips[this.trips.length - 2].toCode = this.trips[0].fromCode
            this.trips[this.trips.length - 2].toAirport = this.trips[0].fromAirport;
            this.trips[this.trips.length - 2].toCityObject = this.trips[0].fromCityObject;
          }
        }

        this.redefineItineraryArray();
        this.searchingValuesFixation();
        this.currentIndex--;
      }
    }

    if (this.trips.length > 1 && !this.trips[1].fromCity) {
      this.trips[1].toCity = this.trips[0].toCity;
      this.trips[1].toLat = this.trips[0].toLat;
      this.trips[1].toLng = this.trips[0].toLng;
      this.trips[1].toCode = this.trips[0].toCode
      this.trips[1].toAirport = this.trips[0].toAirport;
      this.trips[1].toCityObject = this.trips[0].toCityObject;
    }

    this.searchingValuesFixation();
    this.forceUpdate = !this.forceUpdate;
  }

  public cityValidate(currCity: string) {
    if (currCity) {
      this.cityList.filter((city) => {
        if (city.city.toLowerCase().includes(currCity.toLowerCase())) {
          if (city.city.toLowerCase() === currCity.toLowerCase()) {
            this.searchingValuesFixation();
            this.redefineItineraryArray();
          }
          return;
        }
      });
    }
  }

  public selectedClass(selectedClass: string) {
    this.cabinClassTravelers.cabinClass = selectedClass;
  }

  public closeOpenCabClassTrav() {
    this.isCabClassTravOpen = !this.isCabClassTravOpen;
  }

  public allPassengersCounter() {
    this.allPassengers = this.cabinClassTravelers.travelers.adults + this.cabinClassTravelers.travelers.childrens + this.cabinClassTravelers.travelers.infants;
  }

  passengerIncrement(value: number) {
    switch (value) {
      case 1:
        if (this.passengerQuantity < 9) {
          this.passengerQuantity++;
          this.cabinClassTravelers.travelers.adults++;
        }
        break;
      case 2:
        if (this.passengerQuantity < 9) {
          this.passengerQuantity++;
          this.cabinClassTravelers.travelers.childrens++;
        }
        break;
      case 3:
        if (this.cabinClassTravelers.travelers.infants < this.cabinClassTravelers.travelers.adults) {
          this.cabinClassTravelers.travelers.infants++;
        }
        break;

      default:
        break;
    }
    this.allPassengersCounter();
  }

  passengerDecrement(value: number) {
    switch (value) {
      case 1:
        if (this.cabinClassTravelers.travelers.adults > 1) {
          this.cabinClassTravelers.travelers.adults--;
          this.passengerQuantity--;
          if (this.cabinClassTravelers.travelers.infants > this.cabinClassTravelers.travelers.adults) {
            this.cabinClassTravelers.travelers.infants = 0;
          }
        }
        break;
      case 2:
        if (this.cabinClassTravelers.travelers.childrens > 0) {
          this.cabinClassTravelers.travelers.childrens--;
          this.passengerQuantity--;
          if (this.cabinClassTravelers.travelers.infants > this.cabinClassTravelers.travelers.adults) {
            this.cabinClassTravelers.travelers.infants = 0;
          }
        }
        break;
      case 3:
        if (this.cabinClassTravelers.travelers.infants > 0) {
          this.cabinClassTravelers.travelers.infants--;
        }
        break;

      default:
        break;
    }
    this.allPassengersCounter();
  }

  public selectDate(trip: Trip, selectedDate: string) {
    if (!selectedDate) {
      selectedDate = '';
      this.trips[trip.id].date = selectedDate;
      this.searchingValuesFixation();
    }
    this.trips[trip.id].date = selectedDate;
    this.searchingValuesFixation();
    this.forceUpdate = !this.forceUpdate;
  }

  public async searchingValuesFixation() {
    let alliance: Array<string> = [];

    for (let i = 0; i < this.checkedAlliances.length; i++) {
      if (this.checkedAlliances[i].checked) {
        alliance.push(this.checkedAlliances[i].id.toString())
      }
      if (this.checkedAlliances[0].checked) {
        alliance = ['0'];
      }
    }

    await this.redefineItineraryArray();
    for (let i = 0; i < this.trips.length; i++) {
      this.trips[i].id = i;
    }

    let cabinClass = 'Y';

    switch (this.cabinClassTravelers.cabinClass) {
      case 'Economy':
        cabinClass = 'Y'
        break;
      case 'First':
        cabinClass = 'F'
        break;
      case 'Business':
        cabinClass = 'C'
        break;
      default:
        this.cabinClassTravelers.cabinClass = 'Economy'
        break;
    }

    const search = {
      filters:
        {
          airport_change: this.airport_change,
          alliance: alliance,
          cabin: cabinClass,
          cluster: true,
          flexible_dates: this.flexibleDates,
          hub: true,
          include_nearby: this.includeNearby,
          round_trip: this.round_trip
        },
      itinerary: this.itinerary,
      travelers:
        {
          A: this.cabinClassTravelers.travelers.adults,
          C: this.cabinClassTravelers.travelers.childrens,
          I: this.cabinClassTravelers.travelers.infants,
        },
      currency: this.currencies.getCurrent()
    };
    this.searchBody = search;
    store.commit('saveSearch', search);
    store.commit('saveTrips', this.trips);
    return;
  }

  public allAirlinesAreSelected() {
    let selectedAirlines = 0;
    for (let i = 1; i < this.checkedAlliances.length; i++) {
      if (this.checkedAlliances[i].checked) selectedAirlines++;
    }
    if (selectedAirlines === 3) {
      this.checkedAlliances[0].checked = true;
    } else {
      this.checkedAlliances[0].checked = false;
    }
  }

  public selectAllAirlines() {
    this.checkedAlliances[0].checked = !this.checkedAlliances[0].checked;
    if (this.checkedAlliances[0].checked) {
      for (let i = 0; i < this.checkedAlliances.length; i++) {
        this.checkedAlliances[i].checked = true;
      }
      return;
    }
    for (let i = 0; i < this.checkedAlliances.length; i++) {
      this.checkedAlliances[i].checked = false;
    }
  }

  public selectedAirlines() {
    let selectedAirlines = '';
    for (let i = 0; i < this.checkedAlliances.length; i++) {
      if (this.checkedAlliances[i].checked) {
        selectedAirlines += `${this.checkedAlliances[i].title}, `
      }
    }

    if (selectedAirlines === '') {
      selectedAirlines = 'Select Airlines '
    }

    if (selectedAirlines.includes(this.checkedAlliances[0].title)) {
      selectedAirlines = this.checkedAlliances[0].title;
    } else {
      let returnselectedAirlines = selectedAirlines.slice(0, selectedAirlines.length - 2);
      return returnselectedAirlines;
    }

    return selectedAirlines;
  }

  public filterAllAirlines() {
    this.filteredAirlines[0].checked = !this.filteredAirlines[0].checked;
    if (this.filteredAirlines[0].checked) {
      for (let i = 0; i < this.filteredAirlines.length; i++) {
        this.filteredAirlines[i].checked = true;
      }
      return;
    }
    for (let i = 0; i < this.filteredAirlines.length; i++) {
      this.filteredAirlines[i].checked = false;
    }
  }

  public filterAllAirlinesSelected() {
    let selectedAirlines = 0;
    for (let i = 1; i < this.filteredAirlines.length; i++) {
      if (this.filteredAirlines[i].checked) selectedAirlines++;
    }
    if (selectedAirlines === 3) {
      this.filteredAirlines[0].checked = true;
    } else {
      this.filteredAirlines[0].checked = false;
    }
  }

  private redefineItineraryArray() {
    this.itinerary = [];

    this.trips.filter((trip: Trip) => {
      let firstItinerary = trip.fromCityObject;
      if (firstItinerary) {
        firstItinerary.departure_date = moment(trip.date, 'DD-MMM-YYYY').format('DD-MMM-YYYY');
        firstItinerary.byland = '0';
      }

      let secondItinerary = trip.toCityObject;
      if (secondItinerary) {
        secondItinerary.departure_date = '';
        secondItinerary.byland = '0';
      }

      if (this.itinerary.length > 1) {
        if (this.itinerary[this.itinerary.length - 1].city.toLowerCase() !== trip.fromCity.toLowerCase() && this.trips[this.currentIndex - 2].toCity !== undefined) {
          this.itinerary[this.itinerary.length - 1].byland = '1';

          if (firstItinerary)
            if (firstItinerary.id) {
              firstItinerary.departure_date = this.dateFormatter(firstItinerary.departure_date);
              this.itinerary.push(firstItinerary);
            }

        } else {
          this.itinerary[this.itinerary.length - 2].byland = '0';
          this.itinerary[this.itinerary.length - 1].departure_date = trip.date;
        }
        if (secondItinerary)
          if (secondItinerary.city) {
            secondItinerary.departure_date = this.dateFormatter(secondItinerary.departure_date);
            this.itinerary.push(secondItinerary);
            return;
          }
        return;
      }
      if (firstItinerary) {
        firstItinerary.departure_date = this.dateFormatter(firstItinerary.departure_date);
        this.itinerary.push(firstItinerary);
      }
      if (secondItinerary)
        if (secondItinerary.city) {
          secondItinerary.departure_date = this.dateFormatter(secondItinerary.departure_date);
          this.itinerary.push(secondItinerary);
        }
    });

    this.itinerary[0].departure_date = this.trips[0].date;

  }

  private dateFormatter(date: string) {
    return moment(date, 'DD-MMM-YYYY').format('DD-MMM-YYYY')
  }

  private checkFlightsExpiration( itinerary_id: number ) : Promise<boolean>{

    return this.tasksService.runTask(
      [{
        type: this.tasksService.taskCheckExpiration,
        data: {id: itinerary_id}
      }]
    ).then( response => {

      const expired = response.expired || typeof response.expired === "undefined";

      if (!expired) {
        setTimeout(() => {
          return this.checkFlightsExpiration(itinerary_id)
        }, this.checkExpirationFrequency);
      }else{
        this.searchResultsExpired = true;
        this.showFlightsExpirationNotice();
        this.crmLogService.add(CrmLogService.LOG_FLIGHTS_EXPIRED);

      }

      return expired;

    });
  }

  private registerFlightsExpirationNotice(){
    Vue.toasted.register('flightsExpirationNotice', 'These flights may no longer be available. For the best results please',
      {
        type: 'error',
        theme: "toasted-primary",
        position: "top-right",
        singleton: true,
        closeOnSwipe: false,
        action: {
          text: "refresh flights",
          onClick: (e: any, toastObject: any) => {
            this.search().then( result => {
              toastObject.goAway(0)
            } );
            return false;
          }
        }
      });
  }

  private showFlightsExpirationNotice() {
    this.$toasted.global.flightsExpirationNotice();
  }

  created() {
    this.crmLogService.add(CrmLogService.LOG_REACHED_SEARCH);
    window.onscroll = this.dynamicBookButton;
  }

  private dynamicBookButton(): any {
    let topDescription:any = document.getElementById('topDescription');
    if (topDescription) {
      if (topDescription.offsetTop > 190) {       // Prevent flickering
        topDescription.classList.add('scrolled-top');
      }else if(topDescription.offsetTop <=140){   // Prevent flickering
        topDescription.classList.remove('scrolled-top');
      }
    }
  }

  public showCreditInfoOverlayIfNeeded(){
    console.log('show if needed');
    const rcr = this.$store.state.creditData;
    if (rcr && rcr.hasOwnProperty("credit_data")) {
      console.log('has c data');
      if (rcr.credit_data && rcr.credit_date.hasOwnProperty("airline_credit")) {
        console.log('has ac');
        if (rcr.credit_data.hasOwnProperty("passengers_credit")) {
          console.log('has pc');
          this.shouldShowCreditInfoBox = true;
        }
      }
    }
  }
}
